import { render, staticRenderFns } from "./Wohnlage.vue?vue&type=template&id=08cd06a6"
import script from "./Wohnlage.vue?vue&type=script&lang=js"
export * from "./Wohnlage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports